import React from 'react'

import { DateTimeInput, DateTimeInputProps } from '@makyoapp/makyo-tw-ui'

export type CompDateTimePickerProps = DateTimeInputProps

/**
 * CompDateTimePickerCore
 */
export const CompDateTimePickerCore = React.memo(DateTimeInput)

CompDateTimePickerCore.displayName = 'CompDateTimePickerCore'
